import { POPUP_CLICK_TYPE } from "../../constants/Enums";

  
export enum CUSTOM_NUMBER_INPUT_MODULES {
  PEOPLE_EMPLOYEE = 'PEOPLE_EMPLOYEE',
  }

  export enum POPUP_CALLBACKS_TYPE {
    NONE = 'none',
    CLOSE_POPUP = 'closePopup',
    SAVE_CUSTOM_NUMBER = 'saveCustomNumber',
  }

  export type BtnType = {
    title: string;
    class: string;
    clickAction: POPUP_CLICK_TYPE;
  };

  export interface CallBackPayloadType {
    type: POPUP_CALLBACKS_TYPE;
    data?: any;
  }

  export interface ReactSelectOptionsType<K, T> {
    value: T;
    label: K;
    index?: any;
    isDisabled?: boolean;
  }

  export interface UpdateCallBacksRefType {
    storeCallbacksRef: {
      updateContact?: any;
      createSequenceFormat?: any;
    };
    pushDataToParent: CallBackPayloadType;
  }

  export enum INPUT_VIEW_DIRECTION {
    HORIZONTAL = 'HORIZONTAL',
    VERTICAL = 'VERTICAL'
  }

  export const NUMBER_REGEX_PATTERN: string = '^[0-9]+$';

  export const PRODUCTS_CAPS = {
    PEOPLE: 'PEOPLE'
  };

  export enum API_STATUS {
    IDLE = 'idle',
    LOADING = 'loading',
    FAILED = 'failed'
  }

  export enum FORM_ELEMENTS {
    DROPDOWN = 'dropdown',
    INPUT = 'input',
    SEARCHABLE = 'searchable',
    TOGGLE = 'toggle',
    DATE = 'date'
  }
  